module.exports = __webpack_public_path__ + "static/media/icon_lock_big.b8e553ad.svg";